module.exports = __webpack_public_path__ + "img/coininfo-pay-active.9f644341.png";